import { defineComponent as _defineComponent } from 'vue';
import { useI18n } from 'vue-i18n-composable';
import CookiePreferences from '@/views/components/cookies/CookiePreferences.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CustomSettingsModal',
    emits: ["modalClosed"],
    setup(__props, { emit }) {
        const { t } = useI18n();
        function closeModal() {
            emit('modalClosed');
        }
        return { __sfc: true, t, emit, closeModal, CookiePreferences };
    }
});
